
<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <!-- <div class="big_tit">{{$t('shopd.setshopaddr')}}</div> -->
      <div class="introduce">
        <div class="line left_line" />
        <div class="tit">
          {{ $t('shopd.setshopaddr') }}
        </div>
        <div class="line right_line" />
      </div>
      <div class="award_tip">
        {{ $t('d.addrtip') }}
      </div>
    </div>
    <div
      v-if="addr"
      class="wrap_box warp1"
    >
      <!-- <div class="item">
			    <div class="ari_font">{{$t('shopd.address')}}：</div>
			    <input type="text" v-model="addr.addr" >
			</div> -->
      <div class="item">
        <div class="ari_font">
          {{ $t('invest_bank.bank') }}：
        </div>
        <input
          v-model="addr.curname"
          type="text"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('invest_bank.name') }}：
        </div>
        <input
          v-model="addr.name"
          type="text"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('invest_bank.account') }}：
        </div>
        <input
          v-model="addr.tel"
          type="text"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('shopd.region') }}：
        </div>
        <input
          v-model="addr.region"
          maxlength="6"
          max="999999"
          size="6"
          :type="newpasswordInp"
          @click="write_psd = true;"
        >
        <div
          class="eye_bi"
          :class="newpasswordInp=='text'?'eye':''"
          @click="showNewsPwd"
        />
      </div>
    </div>
    <div
      v-if="show"
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('shopd.ok') }}
    </div>
    <van-popup
      v-if="show"
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import {
        DropdownMenu,
        DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "Addr",
        data() {
            return {
				show:true,
				showKeyboard: true,
				write_psd: false,
				psd_val: '',
				eye:1,
				submitType:1,
				newpasswordInp:'password',
                addr: {
                    name: '',
                    tel: '',
                    addr:'',
                    curname:'',
					region:''
                },
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			onInput(key) {
			    this.psd_val = (this.psd_val + key).slice(0, 6);
			    if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.addr.region = this.psd_val;
			    }
			},
			onDelete() {
			    this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
			},
			showNewsPwd() {
			    this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
			},
			start(){
				Fetch('/user/my_addr').then(r=>{
					if(r.data && r.data.tel){
						this.addr = r.data;
						this.show = false;
					}
				})
			},
            submitBtn(){
				// if (!this.addr.name.replace(/\s/g, "")) {
				//     this.$notify("Name cannot be empty!");
				//     return;
				// }
				if (!this.addr.tel.replace(/\s/g, "") && !this.addr.addr.replace(/\s/g, "")) {
				    this.$notify(this.$t('invest_bank.accountin'));
				    return;
				}

				// if (!this.addr.curname.replace(/\s/g, "")) {
				//     this.$notify("Currency Name cannot be empty!");
				//     return;
				// }
				// if (!this.addr.region.replace(/\s/g, "")) {
				//     this.$notify("Withdrawal PIN cannot be empty!");
				//     return;
				// }
				if (this.addr.region=='123456') {
				    this.$notify("출금 비밀번호가 너무 간단해요");
				    return;
				}
                Fetch('/user/addr_add',{
                    ...this.addr
                }).then(r=>{
                    this.$toast({
                    	background: '#07c160',
                    	message: 'Added Success'
                    });
                    this.$router.push('/user');
                })
                
            }
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .van-dropdown-menu {
        position: relative;
        z-index: 10;
        color: #CCCCCC;
    }

    /deep/ .van-dropdown-menu__bar {
        position: relative;
        z-index: 10;
        width: 211px;
        height: 34px;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        text-align: left;
    }

    /deep/ .van-dropdown-item--down {
        width: 211px;
        margin: 0 auto;
        z-index: 12;
        transform: translateX(4px);
    }

    /deep/ .van-dropdown-menu__item {
        justify-content: flex-start;
        color: #ccc;
        background-color: #fff;
    }

    /deep/ .van-dropdown-menu__title {
        width: 100%;
    }

    /deep/ .van-dropdown-menu__title::after {
        width: 13px;
        height: 22px;
        transform: none;
        background: url(../../assets/images/drop.png) no-repeat center center;
        background-size: 100% 100%;
        border: none;
        opacity: 1;
        margin-top: -11px;
        right: 10px;
    }

    /deep/ .van-cell {
        padding: 5px 8px;
    }

    /deep/ .van-cell__title {
        flex: 3;
        white-space: normal;
    }

    /deep/ .van-ellipsis {
        color: #000;
    }

    /deep/ .van-dropdown-item__option {
        color: #ccc;
        border: 1px solid #D9D9D9;
        border-bottom: none;
        border-radius: 4px;
    }

    /deep/ .van-dropdown-item__option:last-child {
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
        color: #000;

        .van-dropdown-item__icon {
            color: #E96259;
        }
    }

    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
        margin:3vw;

        .item {
            height: 50px;
            padding: 0 3vw;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            input {
                line-height: 14px;
				width: 70vw;
            }
        }
    }

    .ari_font {
        width: 30vw;
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 5vh auto 0 auto;
    }
	.red_top_bg {
		height: auto;
		padding-bottom: 20px;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
			img{
				height: 35px;
				margin: 5px;
			}
		}
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 25px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: center;
		    margin: 3px auto 0 auto;
			padding: 5px 25px;
		}
	}
	/deep/ .van-password-input {
	    margin: 50px 28px 0 28px;
	}
	
	/deep/ .van-hairline--left::after {
	    border: 1px solid #ECECEC;
	}
	
	.van-password-input .van-password-input__security::after {
	    border-radius: 0;
	}
	
	.keybord_box {
	    height: 250px;
	    background-color: #F0F0F0;
	    margin-top: 35px;
	    padding: 24px 12px 0 12px;
	
	    .keybord {
	        width: 361px;
	        margin: 24px auto 0 atuo;
	        display: flex;
	        justify-content: space-between;
	        flex-wrap: wrap;
	        text-align: center;
	
	        .key_item {
	            width: 115px;
	            height: 44px;
	            line-height: 44px;
	            font-size: 18px;
	            font-weight: bold;
	            margin-bottom: 6px;
	            background: rgba(255, 255, 255, 1);
	            border-radius: 3px;
	
	            &.no_bg {
	                background: none;
	            }
	
	            &.x {
	                color: #757880;
	                font-weight: bold;
	            }
	        }
	    }
	}
	.eye_bi {
	    width: 21px;
	    height: 25px;
	    background: url(../images/user/eye2.png) no-repeat center center;
	    background-size: 100% auto;
	
	    &.eye {
	        background: url(../images/user/eye1.png) no-repeat center center;
	        background-size: 100% auto;
	    }
	}

	.recharge_wrap { min-height: 100vh; background: #f5f5f5; padding-bottom: calc(var(--app-bottom-menu-height) + 24px + env(safe-area-inset-bottom, 0px)); }
	.red_top_bg { height: 50px; padding-bottom: 0; background: #fff; border-bottom: 1px solid #eee; }
	.back_left { filter: brightness(0); opacity: 1; }
	.red_top_bg .introduce { height: 50px; margin-top: 0; color: #333; font-size: 16px; }
	.red_top_bg .introduce .line { display: none; }
	.red_top_bg .award_tip { display: none; }
	.warp1 { margin: 10px 0 0; background: #fff; }
	.warp1 .item { height: 54px; padding: 0 16px; }
	.ari_font { width: 30%; color: #555; font-size: 13px; font-weight: 400; }
	.warp1 .item input { color: #333; font-size: 14px; }
	.basic_btn { width: calc(100% - 32px); height: 42px; margin: 24px auto 0; border-radius: 4px; background: #ee4d2d; color: #fff; line-height: 42px; }
</style>
